import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Modal } from './modal';

@Injectable()
export class ModalService {

  private readonly modalsStackSubject = new BehaviorSubject<Modal.Init[]>([]);

  public modalsStack(): Observable<Modal.Init[]> {
    return this.modalsStackSubject.asObservable();
  }

  public isActive(): Observable<boolean> {
    return this.modalsStackSubject
      .asObservable()
      .pipe(map(stack => stack.length > 0));
  }

  public open<TData = unknown, TResult = unknown>(component: Type<unknown>, data?: TData): Promise<TResult> {
    return new Promise(resolve => {
      const stack = this.modalsStackSubject.value;
      const recipe: Modal.Init = {
        component,
        data,
        callback: (result) => {
          const currentStack = this.modalsStackSubject.value;
          if (currentStack[currentStack.length - 1] === recipe) {
            resolve(result as TResult);
            this.modalsStackSubject.next(currentStack.slice(0, -1));
            console.debug(`Closing modal at stack index: ${this.modalsStackSubject.value.length}`);
          }
        }
      };
      console.debug(`Opening modal at stack index: ${this.modalsStackSubject.value.length}`);
      this.modalsStackSubject.next([...stack, recipe]);
    });
  }

}
